/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import FGBLabel from '../../components/Elements/FGBLabel/FGBLabel';
import Button from '../../components/Input/Button/Button';
import Layout from '../../components/Layout/Layout';
import PageSection from '../../components/Layout/PageSection/PageSection';
import { CONVERT_CONTENT } from '../../components/Utilities/ContentFunctions';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import { PAGE_PROPS } from '../defaultProps';

import './Presentation.scss';

export default class Presentation extends React.PureComponent {
    render() {
        return (
            <div className="page-Presentation">
                <SnowplowPageViewTracker
                    pageType={PAGE_VIEW_TYPES.CONTENT}
                    pageSection={PAGE_VIEW_SECTIONS.RESEARCH}
                />
                <Layout PAGE_PROPS={this.props.PAGE_PROPS} hasBottomBanner>
                    <PageSection>
                        <section className="content">
                            <header className="info-section">
                                <a className="label-link" href="/research">
                                    <FGBLabel>Research</FGBLabel>
                                </a>
                                <h3 className="text-center presentation-title">
                                    {this.props.title}
                                </h3>
                                {this.props.description && (
                                    <div
                                        className="presentation-description"
                                        dangerouslySetInnerHTML={CONVERT_CONTENT(
                                            this.props.description
                                        )}
                                    />
                                )}
                            </header>
                            <div className="slide-section">
                                <div className="iframe">
                                    <iframe
                                        title={`iframe--${this.props.title}`}
                                        src={this.props.slideShareUrl}
                                        width="100%"
                                        height="600"
                                        allowFullScreen
                                        scrolling="no"
                                    />
                                    <div className="leftMask" />
                                    <div className="rightMask" />
                                </div>
                                {this.props.downloadUrl && (
                                    <a
                                        href={this.props.downloadUrl}
                                        download="fgb-presentation"
                                        className="download-link-wrapper"
                                    >
                                        <div
                                            className="download-btn"
                                            style={{
                                                width: '140px',
                                                margin: 'auto',
                                            }}
                                        >
                                            <Button
                                                type="solid"
                                                value="Download"
                                            />
                                        </div>
                                    </a>
                                )}
                            </div>
                        </section>
                    </PageSection>
                </Layout>
            </div>
        );
    }
}

Presentation.propTypes = {
    /**
     * Global props from the server
     */
    PAGE_PROPS,
    /**
     * Presentation title
     */
    title: PropTypes.string.isRequired,
    /**
     * presentation description
     */
    description: PropTypes.string,
    /**
     * slide url
     */
    slideShareUrl: PropTypes.string.isRequired,
    /**
     * link to download the presentation
     */
    downloadUrl: PropTypes.string.isRequired,
};

Presentation.defaultProps = {
    PAGE_PROPS: { url: { path: '/' } },
    description: '',
};
